// extracted by mini-css-extract-plugin
module.exports = {"sectionHolder":"PreparationTime_sectionHolder__3Ec8O"};